import Meta from '../../components/common/Meta';
import RedesignPageLayout from '../../components/common/RedesignPageLayout';
import Login from '../../components/admin/Login';

const meta = {
    title: '登录 - 管理页面 - 博客中心',
    keywords: '登录',
    description: '博客中心管理后台登录页面。',
};

export default function LoginPage() {
    return (
        <>
            <Meta meta={meta} />
            <RedesignPageLayout>
                <div className="redesign-form-card redesign-form-card--narrow">
                    <Login />
                </div>
            </RedesignPageLayout>
        </>
    );
}
